import { Link } from "react-router-dom";
import "./../../pagescss/Bottombar.css";

const Bottombar = () => {

  const phoneFromStorage = localStorage.getItem('userPhone');



  return (

    <>

     
        <div className="bottombar-container">
          <ul className="bottombar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link">
                <span className="nav-icon">🏠</span>
                <span className="nav-text">Home</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/bookmarked-questions" className="nav-link">
                <span className="nav-icon">⭐</span>
                <span className="nav-text">Mark Ques...</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/bookmarked-pdfs" className="nav-link">
                <span className="nav-icon">📑</span>
                <span className="nav-text">Mark Pdf</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/profile" className="nav-link">
                <span className="nav-icon">👤</span>
                <span className="nav-text">Profile</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/more-options" className="nav-link">
                <span className="nav-icon">☰</span>
                <span className="nav-text">More</span>
              </Link>
            </li>
          </ul>
        </div>
     

    </>

  );
};

export default Bottombar;